/*
 * Module for the Purchase History page
*/
rs.module("content/benefits/estimates/purchasehistory",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            var purchaseHistoryList = $.js(jsSelectors.purchaseHistoryList);
            var listSkeleton = $.js(jsSelectors.listSkeleton);

            $.js(jsSelectors.fundPicker, { required: false }).change(function () {

                // Show list skeleton while we load content.
                listSkeleton.show();
                purchaseHistoryList.hide();

                var values = $(this).val().split("|");

                $.get(
                    backendUrls.retrievePurchaseEstimateHistory,
                    {
                        fundKey: values[0]
                    })
                    .done(function (html) {
                        purchaseHistoryList.html(html);
                    })
                    .always(function () {
                        listSkeleton.hide();
                        purchaseHistoryList.show();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);